import { render, staticRenderFns } from "./ContainerDocumentsDetail.vue?vue&type=template&id=5e4139b5"
import script from "./ContainerDocumentsDetail.vue?vue&type=script&lang=js"
export * from "./ContainerDocumentsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports